/**
 * @description 获取学习任务
 * @author Kody
 */

import Api from '../../path';
import {fetchData} from '@umu/umu-fetch';

export interface IMyTasksParam {
    size: number;
    page: number;
    learn_status: number;
    sort_type?: number;
    unfinished_status?: number;
}

// 学习任务
export interface ITask {
    stage_num: number;
    group_num: number;
    learn_status: number;
    finish_time: number;
    due_time: number;
    over_due: number;
    program_id: number;
    group_id: string;
    session_num: number;
    task_type: number;
    title: string;
    show_pic: string;
    teacher_id: number;
    teacher_name: string;
    teacher_avatar: string;
    share_qrc: string;
    share_card_view: string;
    participate: string;
    assign_url: string;
    teacher_avatar_arr: string[];
    unfinish_task_num: number;
    finish_count: number;
    finish_ratio: number;
    session_url: string;
}

export interface IMyTaskRes {
    data_count: {
        total_num: number;
        complete_num: number;
        uncomplete_num: number;
    };
    page_info: IPageInfo;
    list: ITask[];
}

export function getMyTasks(data: IMyTasksParam): Promise<IResponse<IMyTaskRes>> {
    return fetchData(Api.GET_MY_TASKS, data).then((res: IResponse<IMyTaskRes>) => {
        return res;
    });
}
